import * as d3 from 'd3';
import { AnnotationModelItem, EllipseData } from '../interfaces';

export const drawEllipse = function (wrapper, item: AnnotationModelItem) {
  const data: EllipseData = item.data as EllipseData;
  const w = d3.select(wrapper);
  const rectangle: d3.Selection<SVGEllipseElement, unknown, null, undefined> = w.select(`#item${item.id}`).node()
    ? w.select(`#item${item.id}`)
    : w.append('ellipse');

  rectangle
    .attr('id', `item${item.id}`)
    .attr('stroke', data.color)
    .style('stroke-width', data.strokeWidth)
    .attr('rx', data.size[0] || 1)
    .attr('ry', data.size[1] || 1)
    .attr('fill', 'none');

  return rectangle;
};
